"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InPlaceMagnifyContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var MaginfyContainer_1 = require("./MaginfyContainer");
var InPlaceMagnifyContainer = function InPlaceMagnifyContainer(props) {
  var style = props.style,
    rest = __rest(props, ["style"]);
  var computedStyle = Object.assign({
    position: 'absolute',
    top: '0px',
    left: '0px',
    zIndex: 100
  }, style);
  return (0, jsx_runtime_1.jsx)(MaginfyContainer_1.MagnifyContainer, Object.assign({
    inPlaceMode: true,
    style: computedStyle
  }, rest), void 0);
};
exports.InPlaceMagnifyContainer = InPlaceMagnifyContainer;